import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What exactly is a land joint venture?",
    answer:
      "A joint venture is a partnership between you and Landivo: you contribute the property, and we contribute the marketing, financing structure, and buyer network needed to sell it. When it sells, we split the profit according to the terms we agree on upfront.",
  },
  {
    question: "Do I still own my property during the process?",
    answer:
      "Yes. You retain ownership until the property actually sells. The joint venture agreement only defines how the sale proceeds are shared once a buyer closes.",
  },
  {
    question: "How is the profit split determined?",
    answer:
      "It depends on the property's condition, location, and what each side contributes to the sale. We walk through the numbers with you before you sign anything, so there are no surprises later.",
  },
  {
    question: "Are there any upfront costs or fees?",
    answer:
      "No. There are no listing fees or out-of-pocket marketing costs to enter into a joint venture with us.",
  },
  {
    question: "What if my land doesn't sell right away?",
    answer:
      "We revisit pricing and marketing strategy together. Since there's no upfront cost to you, there's no pressure to accept a bad offer just to close quickly.",
  },
  {
    question: "How long does the process typically take?",
    answer:
      "Every property is different, but many joint venture sales close within 30-60 days once a buyer is lined up, depending on the market and property type.",
  },
  {
    question: "What types of land qualify for a joint venture?",
    answer:
      "We evaluate raw land, rural acreage, and vacant lots across our partnered Texas markets. Share your address above and our team will let you know if it's a fit.",
  },
  {
    question: "How is this different from listing with a traditional agent?",
    answer:
      "With a traditional listing, you're responsible for commissions and carrying costs while the property sits on the market. In a joint venture, we share the risk and the reward — you don't pay us unless the property sells.",
  },
];

const JVFAQ = () => (
  <section className="bg-white py-14 sm:py-20">
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <div className="mb-10 text-center sm:mb-14">
        <p className="text-xs font-semibold uppercase tracking-wide text-[#C1694F] sm:text-sm">
          FAQ
        </p>
        <h2 className="mt-2 text-2xl font-bold text-[#16213E] sm:text-4xl">
          Questions About Joint Venturing Your Land
        </h2>
      </div>

      <Accordion type="single" collapsible className="w-full space-y-3" id="jv-faq-accordion">
        {faqs.map((faq, index) => (
          <AccordionItem
            key={faq.question}
            value={`item-${index}`}
            className="rounded-xl border border-slate-200 bg-[#F5F3EF] px-5 py-1 sm:px-6"
          >
            <AccordionTrigger
              className="text-left text-sm font-semibold text-[#16213E] hover:no-underline sm:text-base"
              id={`jv-faq-trigger-${index}`}
            >
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-slate-600 sm:text-base">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default JVFAQ;
